import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProductAccessService } from 'src/app/services/product-access/product-access.service';
import { AuthBridgeService } from 'src/app/services/auth-bridge.service';

export function requireProductAccess(productId: string, fallbackUrl = '/product-disabled'): CanActivateFn {
  return async () => {
    const productAccessService = inject(ProductAccessService);
    const router = inject(Router);
    const authBridge = inject(AuthBridgeService);

    // Runs concurrently with AuthGuard; wait for the centralized session before
    // checking access (checkProductAccess reads the user doc → needs currentUser).
    await authBridge.ensureReady();

    const hasAccess = await productAccessService.checkProductAccess(productId);
    return hasAccess || router.parseUrl(fallbackUrl);
  };
}
